<template>
    <div class="box">
      <div class="box1">
          <img src="../../assets/image/end.png" alt="">
          <div>
            <h1>{{ headline }}!</h1>
          </div>
      </div>
      <div class="box-btn">
          <van-button @click="routeClick" round type="info">返回</van-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        headline: '', // 文字切换
      }
    },
    created() {
      switch(this.$route.query.headline) {
        case '0': 
          this.headline = "重置成功";
          break;
        case '1':
          this.headline = "修改成功";
          break;
        case '2':
          this.headline = "兑换成功";
          break;
        case '3':
          this.headline = "兑换取消成功";
          break;
        default:
          this.headline = "...";
      }
    },
    methods: {
      routeClick() {
        switch(this.$route.query.headline) {
          case '0':
            this.headline = "重置成功";
            if(this.$route.query.type==1){ // h5 页面修改密码 返回h5登录界面
              this.$router.push('/app-h5-cn/page/login');
            }else if (window.HoLiObject) {
                window.HoLiObject.h5LogOut();
            } else {
              window.webkit.messageHandlers.HoLiObject.postMessage({
                  method: "h5LogOut"
              });
            }
            break;
          case '1':
            this.headline = "修改成功";
            this.$router.push('/app-h5-cn/page/myInfo');
            break;
          case '2':
            this.headline = "兑换成功";
            this.$router.back();
            break;
          case '3':
            this.headline = "兑换取消成功";
            this.$router.back();
            break;
          default:
            this.$router.push('/app-h5-cn/page/personalCenter');
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .box1 {
      padding-top: 50px;
      width: 100%;
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
          color: #63D56D;
      }
      .p2Size {
          position: relative;
          top: -10px;
          color: rgb(128, 126, 126);
      }
  }
  .box-btn {
      margin-top: 40px;
      width: 100%;
      display: flex;
       flex-direction: column ;
      align-items: center;
      .btn-margin-style {
        margin-top: 20px;
        color: #0096FC;
      }
  }
  /deep/ .van-button--info {
      background-color: rgb(0,216,117);
      border: 1px solid rgb(0,216,117);
  }
  /deep/ .van-button--round {
      width: 40%;
  }
  </style>